import React, { useState } from 'react';
import AcademyHeader from '../../../components/LP/AcademyHeader';
import LPFooter from '../../../components/LP/LPFooter';
import SEO from '../../../components/SEO/SEO';

const purposes = [
  { id: 'academy_apply', title: 'アカデミーへの申し込み・詳細を聞きたい', defaultMessage: 'SrWithアカデミーについて詳しく教えてください。' },
  { id: 'consultation', title: '個別相談の予約', defaultMessage: '個別相談を希望します。' },
  { id: 'other', title: 'その他のご質問', defaultMessage: '' },
];

const AcademyContactPage = () => {
  const [selectedPurpose, setSelectedPurpose] = useState('');
  const [formData, setFormData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitResult, setSubmitResult] = useState(null);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handlePurposeSelect = (id) => {
    setSelectedPurpose(id);
    const purpose = purposes.find((p) => p.id === id);
    if (purpose?.defaultMessage) {
      setFormData((prev) => ({ ...prev, inquiry: purpose.defaultMessage }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitResult(null);

    try {
      const response = await fetch('/api/contact.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userType: 'sr',
          purposeType: selectedPurpose,
          ...formData,
        }),
      });
      const data = await response.json();
      setSubmitResult(data.success ? 'success' : 'error');
    } catch {
      setSubmitResult('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col font-noto bg-lp-cream text-lp-charcoal">
      <SEO
        title="個別相談・お問い合わせ｜SrWithアカデミー"
        description="SrWithアカデミーへのお申し込み、個別相談のご予約、その他ご質問はこちらから。"
      />

      <AcademyHeader />

      <main className="flex-grow pt-[48px]">
        <section className="relative bg-lp-charcoal overflow-hidden">
          <div className="relative max-w-[860px] mx-auto px-5 py-16 md:py-20 text-center">
            <h1 className="font-noto-serif text-2xl md:text-4xl font-bold text-white mb-4">
              個別相談・お問い合わせ
            </h1>
            <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-[540px] mx-auto mb-8">
              お気軽にご相談ください。押し売りは一切ありません。
            </p>
            <a
              href="https://timerex.net/s/shotsu923_b21b/84385a85"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-8 py-4 bg-lp-rose text-white font-bold rounded-lg hover:opacity-90 transition-opacity text-sm md:text-base"
            >
              個別相談を予約する（無料）
            </a>
          </div>
        </section>

        <section className="py-16 md:py-20">
          <div className="max-w-[600px] mx-auto px-5">

            {submitResult === 'success' ? (
              <div className="bg-white rounded-2xl p-8 md:p-12 text-center shadow-lg">
                <div className="text-4xl mb-4">&#10003;</div>
                <h2 className="font-noto-serif text-xl md:text-2xl font-bold text-lp-charcoal mb-4">
                  お問い合わせありがとうございます
                </h2>
                <p className="text-sm text-lp-charcoal-mid leading-relaxed mb-8">
                  内容を確認の上、1〜2営業日以内にご連絡いたします。
                </p>
                <a
                  href="/lp/academy"
                  className="inline-block px-8 py-3 bg-lp-rose text-white font-medium rounded-lg hover:opacity-90 transition-opacity text-sm"
                >
                  アカデミーページに戻る
                </a>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="bg-white rounded-2xl p-8 md:p-10 shadow-lg space-y-6">

                {/* ハニーポット */}
                <div style={{ position: 'absolute', left: '-9999px' }} aria-hidden="true">
                  <input
                    type="text"
                    name="website_url"
                    tabIndex="-1"
                    autoComplete="off"
                    onChange={(e) => handleInputChange('website_url', e.target.value)}
                  />
                </div>

                {/* 目的選択 */}
                <div>
                  <label className="block text-sm font-bold text-lp-charcoal mb-3">ご用件 *</label>
                  <div className="space-y-2">
                    {purposes.map((p) => (
                      <button
                        key={p.id}
                        type="button"
                        onClick={() => handlePurposeSelect(p.id)}
                        className={`w-full text-left px-4 py-3 rounded-lg border-2 transition-all text-sm ${
                          selectedPurpose === p.id
                            ? 'border-lp-rose bg-lp-rose/5 text-lp-charcoal font-bold'
                            : 'border-gray-200 text-lp-charcoal-mid hover:border-gray-300'
                        }`}
                      >
                        {p.title}
                      </button>
                    ))}
                  </div>
                </div>

                {/* お名前 */}
                <div>
                  <label className="block text-sm font-bold text-lp-charcoal mb-2">お名前 *</label>
                  <input
                    type="text"
                    required
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-lp-rose focus:outline-none text-sm"
                    placeholder="例: 田中太郎"
                    onChange={(e) => handleInputChange('name', e.target.value)}
                  />
                </div>

                {/* メールアドレス */}
                <div>
                  <label className="block text-sm font-bold text-lp-charcoal mb-2">メールアドレス *</label>
                  <input
                    type="email"
                    required
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-lp-rose focus:outline-none text-sm"
                    placeholder="例: info@example.com"
                    onChange={(e) => handleInputChange('email', e.target.value)}
                  />
                </div>

                {/* 事務所名 */}
                <div>
                  <label className="block text-sm font-bold text-lp-charcoal mb-2">事務所名（任意）</label>
                  <input
                    type="text"
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-lp-rose focus:outline-none text-sm"
                    onChange={(e) => handleInputChange('officeName', e.target.value)}
                  />
                </div>

                {/* お問い合わせ内容 */}
                <div>
                  <label className="block text-sm font-bold text-lp-charcoal mb-2">お問い合わせ内容</label>
                  <textarea
                    rows={4}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-lp-rose focus:outline-none text-sm resize-none"
                    value={formData.inquiry || ''}
                    onChange={(e) => handleInputChange('inquiry', e.target.value)}
                  />
                </div>

                {submitResult === 'error' && (
                  <p className="text-red-600 text-sm text-center">送信に失敗しました。時間をおいて再度お試しください。</p>
                )}

                <button
                  type="submit"
                  disabled={isSubmitting || !selectedPurpose}
                  className="w-full py-4 bg-lp-rose text-white font-bold rounded-lg hover:opacity-90 transition-opacity disabled:opacity-50 text-sm"
                >
                  {isSubmitting ? '送信中...' : '送信する'}
                </button>
              </form>
            )}
          </div>
        </section>
      </main>

      <LPFooter />
    </div>
  );
};

export default AcademyContactPage;
